export default function() {
  return Array.from(this);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-hierarchy/src/hierarchy/descendants.js
// module id = null
// module chunks = 